import React, { useState, useEffect } from 'react';
import { brandService } from '../api/brandService';
import Table from '../components/Common/Table';
import Modal from '../components/Common/Modal';
import Pagination from '../components/Common/Pagination';
import SearchBar from '../components/Common/SearchBar';
import BrandForm from '../components/Brands/BrandForm';
import '../components/Common/Common.css';

function Brands() {
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editingBrand, setEditingBrand] = useState(null);

  const fetchBrands = async () => {
    try {
      setLoading(true);
      const response = await brandService.getBrands({
        page: currentPage,
        search: searchTerm,
        per_page: 15,
      });
      setBrands(response.data);
      setLastPage(response.last_page || 1);
    } catch (error) {
      console.error('Error fetching brands:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBrands();
  }, [currentPage, searchTerm]);

  const handleDelete = async (id) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer cette marque?')) {
      try {
        await brandService.deleteBrand(id);
        fetchBrands();
      } catch (error) {
        console.error('Error deleting brand:', error);
        alert('Échec de la suppression de la marque');
      }
    }
  };

  const handleEdit = (brand) => {
    setEditingBrand(brand);
    setShowModal(true);
  };

  const handleCreate = () => {
    setEditingBrand(null);
    setShowModal(true);
  };

  const handleFormSuccess = () => {
    setShowModal(false);
    setEditingBrand(null);
    fetchBrands();
  };

  const columns = [
   { key: 'id', label: 'ID' },
    {
      key: 'logo',
      label: 'Image',
      render: (val) => val ? (
        <img src={val} alt="Product" style={{ width: '60px', height: '60px', objectFit: 'contain', borderRadius: '4px' }} />
      ) : 'Aucune image'
    },
    { key: 'name', label: 'Nom' },
    { key: 'slug', label: 'Slug' },
  ];

  return (
    <div>
      <div className="page-header">
        <h1>Marques</h1>
        <button onClick={handleCreate} className="btn btn-primary">
          Ajouter une marque
        </button>
      </div>

      <div className="filters">
        <div className="filters-grid">
          <div style={{ gridColumn: 'span 2' }}>
            <SearchBar
              value={searchTerm}
              onChange={setSearchTerm}
              placeholder="Rechercher des marques par nom ou description..."
              onClear={() => setCurrentPage(1)}
            />
          </div>
        </div>
      </div>

      <Table
        columns={columns}
        data={brands}
        loading={loading}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />

      <Pagination
        currentPage={currentPage}
        lastPage={lastPage}
        onPageChange={setCurrentPage}
      />

      <Modal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        title={editingBrand ? 'Modifier la marque' : 'Ajouter une marque'}
      >
        <BrandForm
          brand={editingBrand}
          onSuccess={handleFormSuccess}
          onCancel={() => setShowModal(false)}
        />
      </Modal>
    </div>
  );
}

export default Brands;
